(function () {
	'use strict';

	angular.module('atheer.job').controller('JobController', JobController);

	/* @ngInject */
	function JobController(
		$rootScope,
		$state,
		$scope,
		$sce,
		$cookies,
		BuildLanguages,
		$location,
		$window,
		$mdSidenav,
		postMessageSecurity
	) {
		var vm = this;
		vm.ngxUrlTrusted = null;
		vm.isIFrameDataLoaded = false;

		function setNgxPageUrl() {
			var ngxUrl = null;
			var path = $location.path();
			var hostUrl =
				location.hostname === 'localhost'
					? 'https://' + location.hostname + ':4200'
					: location.origin;

			if ($state.current.name == 'storm.jobs') {
				ngxUrl = hostUrl + '/ngx/jobs';
			} else if ($state.current.name == 'storm.job-schedule') {
				ngxUrl = hostUrl + '/ngx/job-scheduler';
			} else if ($state.current.name == 'storm.jobs-search') {
				ngxUrl = hostUrl + '/ngx/jobs/search';
				if ($location.search().search) {
					ngxUrl += '?search=' + encodeURIComponent($location.search().search);
				}
			} else if ($state.current.name == 'storm.job-detail-by-job-number') {
				var jobNumber = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/jobs/jobNumber/' + jobNumber;
			} else if ($state.current.name == 'storm.job-detail') {
				var id = path.split('/').pop();
				if ($location.search().action) {
					ngxUrl = hostUrl + '/ngx/jobs/' + id + '?action=' + $location.search().action;
				}else {
					ngxUrl = hostUrl + '/ngx/jobs/' + id;
				}
			} else if ($state.current.name == 'storm.job-execute') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/job/execute/' + id;
			} else if ($state.current.name == 'storm.new-job') {
				var asset = $location.search().asset;
				ngxUrl = hostUrl + '/ngx/jobs/new' + (asset ? '?asset=' + encodeURIComponent(asset) : '');
			} else if ($state.current.name == 'storm.edit-job-by-job-number') {
				var id = path.replace(/\/$/, '').split('/').pop();
				ngxUrl = hostUrl + '/ngx/jobs/edit/jobNumber/' + id;
			} else if ($state.current.name == 'storm.edit-job') {
				var id = path.split('/').pop();
				ngxUrl = hostUrl + '/ngx/jobs/edit/' + id;
			} else {
				ngxUrl = ngxUrl = hostUrl + '/ngx/jobs';
			}

			vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
			$rootScope.selectedLeftNavMenu = 'jobs';
		}

		vm.togglePanel = function (componentId, session) {
            if (session) {
                vm.sessionModel = session;
            }

            if (componentId == "insightsPanel") {
                vm.panelToShow = "insightsPanel";
            } else if (componentId == "recordingsPanel") {
                vm.panelToShow = "recordingsPanel";
            }

            $mdSidenav(componentId)
                .toggle()
                .then(function () {});
        };

		function handleNgxEvent(event) {
			if (event.origin !== postMessageSecurity.getNgxIframeTargetOrigin()) {
				return;
			}
			if (event.data.ngxLocationChanged) {
				var ngState = event.data.ngxLocationChanged.ngState;
				var id = event.data.ngxLocationChanged.id;
				var queryParams = event.data.ngxLocationChanged.queryParams;
				vm.isIFrameDataLoaded = true;
				scopeApply();

				if (ngState === 'storm.jobs-search' && queryParams) {
					var searchParams = {};
					if (queryParams) {
						var params = queryParams.split('&');
						params.forEach(function(param) {
							var keyValue = param.split('=');
							if (keyValue.length === 2) {
								searchParams[keyValue[0]] = decodeURIComponent(keyValue[1]);
							}
						});
					}
					$state.transitionTo(ngState, searchParams, {
						location: true,
						inherit: true,
						relative: $state.$current,
						notify: false
					});
				} else if (id == null) {
					$state.transitionTo(ngState, null, {
						location: true,
						inherit: true,
						relative: $state.$current,
						notify: false
					});
				} else {
					$state.transitionTo(
						ngState,
						{
							id: id
						},
						{
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
						}
					);
				}
			}
			
			if (event.data.type === "open_job_session_stats") {
                vm.togglePanel("insightsPanel", event.data.sessionDetail);
            }
		}

		var scopeApply = function (fn) {
			var phase = $scope.$root.$$phase;
			if (phase !== "$apply" && phase !== "$digest") {
				return $scope.$apply(fn);
			}
		};

		function sendMessageToIframe(payload) {
            var iFrame = document.getElementById("ngxFrame").contentWindow;
            var targetOrigin = postMessageSecurity.getNgxIframeTargetOrigin();
            iFrame.postMessage(payload, targetOrigin);
        }

		function isJobDetailPage() {
			return ["storm.job-detail", "storm.job-detail-by-job-number"].includes($state.current.name);
		}

		function isSelectedJobUpdated(payload) {
			return [
				payload.job.id,
				payload.job.guid,
				payload.job.jobNumber.toString()
			].includes($state.params.id) 
		}

        /**
         * Listens for the updateSessionLinkedJobsResource event and
		 * updates the session linked jobs resource only if the job is
		 * the same as the job in the current state.
         */
        var updateSessionLinkedJobsResourceListener = $rootScope.$on(
            "updateSessionLinkedJobsResource",
            function (event, payload) {
                if (
                    isJobDetailPage() &&
                    isSelectedJobUpdated(payload)
                ) {
                    sendMessageToIframe({
                        type: "update_session_linked_jobs",
                        payload: payload
                    });
                }
            }
        );

		var showSessionRelatedPanelListener = $rootScope.$on('showSessionRelatedPanel', function(event, toBeClosedPanel, toBeOpenedPanel, session) {
			vm.sessionModel = session;
			vm.togglePanel(toBeClosedPanel);
			vm.togglePanel(toBeOpenedPanel, session);
		});

		$window.addEventListener('message', handleNgxEvent, false);

		// Unregister
		$scope.$on('$destroy', function () {
			window.removeEventListener('message', handleNgxEvent, false);
			updateSessionLinkedJobsResourceListener();
			showSessionRelatedPanelListener();
		});

		setNgxPageUrl();
	}
})();
